import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import Typography from '@material-ui/core/Typography';

import Icon from '@material-ui/core/Icon';
import Card from '@material-ui/core/Card';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';

import ServiceIcon from 'components/ServiceIcon/ServiceIcon';

const propTypes = {
  plan: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  service: PropTypes.string.isRequired,
  isORv4Admin: PropTypes.bool.isRequired,
  classes: PropTypes.shape({}).isRequired,
};

const defaultProps = {};

export function UnstyledInstanceItem({ plan, name, service, isORv4Admin, classes }) {
  // Redo this link when we have a way to login and redirect to a customer's instance.
  // var ORv4Href = `${process.env.REACT_APP_ORV4_URL}instances#/v2/${service}/details/${id}`;
  const ORv4Href = process.env.REACT_APP_ORV4_SSO_LOGIN;
  return (
    <Card
      classes={{
        root: classes.panel,
      }}
      TransitionProps={{ unmountOnExit: true }}
    >
      <div className={classes.orv4Color} />
      <ServiceIcon
        className={classes.serviceIcon}
        service={service}
        isAlpha={false}
        status="Ready"
        badgeClass={classes.badgeClass}
      />
      <div className={classes.instanceInfo}>
        <Typography className={classes.name} variant="h6">
          {name}
        </Typography>
        <Typography variant="caption" className={classes.productInfo}>
          {service}
        </Typography>
        <Typography variant="caption" className={classes.productInfo}>
          {plan}
          {service === 'redis' ? 'MB' : 'GB'}
        </Typography>
      </div>

      {isORv4Admin && (
        <div className={classes.lastColumn}>
          <Tooltip
            title={
              <div>
                Manage this instance on
                <br />
                app.objectrocket.com
              </div>
            }
            placement="left"
          >
            <Button variant="contained" className={classes.goORv4}>
              <a className={classes.link} href={ORv4Href} rel="noopener noreferrer" target="_blank">
                <Icon className={classes.instanceLinkIcon}>open_in_new</Icon>
              </a>
            </Button>
          </Tooltip>
        </div>
      )}
    </Card>
  );
}

UnstyledInstanceItem.propTypes = propTypes;
UnstyledInstanceItem.defaultProps = defaultProps;

const styles = (theme) => ({
  orv4Color: {
    minHeight: theme.spacing(10),
    width: theme.spacing(0.75),
    backgroundColor: theme.customColors.sky,
  },
  serviceIcon: {
    height: '40px',
    width: '45px',
    margin: `${theme.spacing(0.5)}px ${theme.spacing(1)}px ${theme.spacing(1)}px ${theme.spacing(
      1,
    )}px`,
    paddingTop: theme.spacing(0.5),
    alignSelf: 'center',

    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  instanceInfo: {
    alignSelf: 'center',

    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(1),
    },
  },
  panel: {
    '&:first-child': {
      marginTop: `${theme.spacing(3)}px !important`,
    },
    '&:last-child': {
      marginBottom: '20rem',
    },
    marginTop: `${theme.spacing(1)}px`,
    marginBottom: 0,
    borderTop: ['1px', 'solid', theme.customColors.lightGrey].join(' '),
    borderRadius: 0,
    boxShadow:
      '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
    display: 'flex',
    position: 'relative',
  },
  badgeClass: {
    right: 20,
  },
  name: {
    whiteSpace: 'pre-wrap' /* css-3 */,
    whiteSpace: '-moz-pre-wrap' /* Mozilla, since 1999 */, // eslint-disable-line no-dupe-keys
    whiteSpace: '-pre-wrap' /* Opera 4-6 */, // eslint-disable-line no-dupe-keys
    whiteSpace: '-o-pre-wrap' /* Opera 7 */, // eslint-disable-line no-dupe-keys
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    wordBreak: 'break-all' /* Check this on Safari */,
    fontFamily: '"Libre Medium", sans-serif',
  },
  productInfo: {
    lineHeight: '1.1rem',
    display: 'block',
  },
  lastColumn: {
    alignSelf: 'center',
    position: 'absolute',
    right: '20px',
  },
  instanceLinkIcon: {
    color: theme.customColors.black,
    margin: theme.spacing(1),
  },
  goORv4: {
    height: '40px',
    padding: '0',
    minWidth: 'auto',
    backgroundColor: theme.customColors.sky,
    boxShadow:
      '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)',
  },
  link: {
    textDecoration: 'none',
  },
});

export default withStyles(styles)(UnstyledInstanceItem);
